import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import "./header.css";
import Logo from "../Images/qp.png";
import profilePic from "../Images/harsh.jpg";
import { House, ChevronDown, LogOut, User } from "lucide-react";
import HomeIcon from "@mui/icons-material/Home";
import defaultProfile from "../Images/profile-user.png";
import LogoutIcon from "../Images/logout-icon.png";
import CheckIcon from "../Images/arrow_downn.svg";
import account from "../Images/accout.png";
import { useQuery } from "@apollo/client";
import {
  CURRENT_USER_ACCOUNT,
  CURRENT_USER_PROFIILE,
} from "../services/userApi";

const Header = ({ setIsAuthenticated = () => { } }) => {
  const username = localStorage.getItem("name");
  const location = useLocation();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [user, setuser] = useState(null);
  const [activeNav, setActiveNav] = useState("dashboard");
  const dropdownRef = useRef(null);
  const profileRef = useRef(null);

  // Optimized GraphQL queries with cache-first and no network status notifications
  const {
    loading: accountsLoading,
    error: accountsError,
    data: accountsData,
  } = useQuery(CURRENT_USER_ACCOUNT, {
    fetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: false
  });

  const {
    loading: profileLoading,
    error: profileError,
    data: profileData,
  } = useQuery(CURRENT_USER_PROFIILE, {
    fetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: false
  });

  const accountdata = accountsData?.currentUserAccount;
  const accoundId = accountsData?.currentUserAccount?.id;
  const userdata = profileData?.currentUserProfile;
  const userId = userdata?.id;
  const isLoading = !userdata;

  useEffect(() => {
    sessionStorage.setItem("accountId", accoundId);
    sessionStorage.setItem("userId", userId);
  }, [accoundId, userId]);

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      setActiveNav("dashboard");
    } else if (
      location.pathname.includes("/leads") ||
      location.pathname === "/assign"
    ) {
      setActiveNav("leads");
    } else if (location.pathname.includes("/fls")) {
      setActiveNav("fls");
    } else if (location.pathname.includes("/client")) {
      setActiveNav("client");
    }
  }, [location.pathname]);

  const handleNavClick = (navItem) => {
    setActiveNav(navItem);

    if (navItem === "dashboard") {
      navigate("/dashboard");
    } else if (navItem === "leads") {
      navigate("/leads");
    } else if (navItem === "fls") {
      navigate("/fls");
    } else if (navItem === "client") {
      navigate("/client")
      sessionStorage.removeItem("leads_filter_state");
    }
  };

  const handlelogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (confirmLogout) {
      localStorage.removeItem("token");
      localStorage.removeItem("name");
      // sessionStorage.removeItem("dashboardRoleId");
      window.location.href = "/login";
    }
  };

  // Handle clicks outside of dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        profileRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !profileRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (location.pathname === "/upload") {
    return null;
  }

  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  const logout = () => {
    localStorage.removeItem("accessToken");
    sessionStorage.removeItem("dashboardRoleId");
    sessionStorage.removeItem("accountId");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("leads_filter_state");
    setIsAuthenticated(false);
    window.location.href = "/login";
  };

  const getInitials = (name) => {
    if (!name || name === "N/A") return "NA";
    return name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <header className="main-header">
      <div className="header-container">
        {/* Left section with logos */}
        <div className="header-left">
          <div className="logo-container">
            {accountdata?.id == 13 && (
              <img src={Logo} alt="" className="default-logo_13" />
            )}
            {accountdata?.id != 13 && (
              <>
                <img src={Logo} alt="" className="default-logo" />
                <img src={accountdata?.smallLogoUrl} className="clon-logo" />
              </>
            )}
          </div>
        </div>

        {/* Middle section with navigation buttons */}
        {location.pathname !== "/client" && (
          <div className="header-middle">
            <nav className="main-nav">
              <ul className="nav-buttons">
                {/* Show Dashboard and Users only if accountId is 1 */}
                {accoundId === 1 && (
                  <>
                    <li>
                      <button
                        className={`nav-button ${activeNav === "client" ? "active" : ""
                          }`}
                        onClick={() => handleNavClick("client")}
                      >
                        Clients
                      </button>
                    </li>
                    <li>
                      <button
                        className={`nav-button ${activeNav === "dashboard" ? "active" : ""
                          }`}
                        onClick={() => handleNavClick("dashboard")}
                      >
                        <span className="home-icon">
                          <HomeIcon />
                        </span>
                      </button>
                    </li>
                    <li>
                      <button
                        className={`nav-button ${activeNav === "leads" ? "active" : ""
                          }`}
                        onClick={() => handleNavClick("leads")}
                      >
                        Leads
                      </button>
                    </li>
                    <li>
                      <button
                        className={`nav-button ${activeNav === "fls" ? "active" : ""
                          }`}
                        onClick={() => handleNavClick("fls")}
                      >
                        Users
                      </button>
                    </li>
                  </>
                )}
              </ul>
            </nav>
          </div>
        )}

        <div className="profile-container">
          <div
            className={`profile-wrapper ${isDropdownOpen ? "dropdown-open" : ""
              } ${isHovered && !isDropdownOpen ? "hovered" : ""}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div className="profile-button" onClick={toggleDropdown}>
              <div className="check-icon-wrapper">
                <img src={CheckIcon} alt="Check" className="check-icon" />
              </div>

              <div className="profile-details">
                <div className="profile-text">
                  <p className="profile-name">
                    {isLoading ? "Loading..." : userdata?.name}
                  </p>
                </div>

                <div className="profile-image-wrapper">
                  {userdata?.profilePicture ? (
                    <img
                      src={userdata.profilePicture}
                      alt="Profile"
                      className="profile-image"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                  ) : (
                    <div className="profile-initials">
                      {getInitials(userdata?.name)}
                    </div>
                  )}
                  <div className="profile-initials" style={{ display: "none" }}>
                    {getInitials(userdata?.name)}
                  </div>
                </div>
              </div>
            </div>

            {/* Always render the dropdown but control visibility with CSS */}
            <div className="logout-section">
              <button className="logout-button" onClick={logout}>
                <img src={LogoutIcon} alt="Logout" className="logout-icon" />
                <span>LOGOUT</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;